var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("footer", { staticClass: "custom-footer" }, [
      _c("div", { staticClass: "row footer-margin" }, [
        _c("div", { staticClass: "col-md-6 col-sm-4" }, [
          _c(
            "a",
            { attrs: { target: "_blank", href: "https://www.hungerhub.com/" } },
            [
              _c("img", {
                staticClass: "logo-hungerhub",
                attrs: {
                  src: require("../assets/img/hh-logo-white.png"),
                  alt: "hungerhub logo",
                  "text-align": "center",
                  "data-retina": "true"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "address" }, [
            _c("p", [
              _vm._v(
                "\n          hungerhub is Canada's leading catering & office meal delivery\n          platform\n        "
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-3 col-sm-4" }, [
          _c("h3", [_vm._v("Made with ♥️ in Canada")]),
          _vm._v(" "),
          _c("div", [
            _c(
              "a",
              {
                staticClass: "download-text",
                attrs: { href: "https://www.hungerhub.com/", target: "_blank" }
              },
              [_vm._v("\n          Learn more about hungerhub\n        ")]
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-md-3 col-sm-4", attrs: { id: "newsletter" } },
          [
            _c("h3", [_vm._v("Need Help?")]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3" }, [
              _c("span", [
                _vm._v(
                  "\n          Start live chat with one of our agents.\n          "
                ),
                _c("br"),
                _vm._v("Weekdays : 9 AM-7 PM\n        ")
              ])
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25824a13", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25824a13","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuestFooter.vue
// module id = null
// module chunks = 